'use strict';

const BaseView = require('./base');
const SectionMapPresenter = require('../presenters/sectionMap');

class SectionMapView extends BaseView {
  initialize() {
    this.setModule('glive_booking_redesign');
    this.templateName = 'sectionMap';
    this.presenter = SectionMapPresenter;
  }

  render() {
    super.render(...arguments);

    const imageUrl = this.model.get('currentSeatMapUrl');
    const mapContainer = this.$el.find('.section-map-wrapper');

    if (imageUrl) {
      const scaledImageUrl = `${imageUrl}&w=${mapContainer.width() * 2}`;
      mapContainer.append(`<img src="${scaledImageUrl}" id="seat-map-image" />`);
    }

    $('#seat-map-image').on('load', this.imageLoadedHandler.bind(this));
    $('#seat-map-image').on('error', this.imageErrorHandler.bind(this));
    return this;
  }

  imageLoadedHandler() {
    const mapContainer = this.$el.find('.section-map-wrapper');
    const image = this.$el.find('#seat-map-image');

    mapContainer.removeClass('gig-spinner');
    image.addClass('loaded');
    this.$el.find('#image-loading-error').hide();
    this.$el.find('.zoom-button').attr('disabled', false);

    this.saveOriginalImageSize(image);
    this.setImageSize(mapContainer, image);
  }

  saveOriginalImageSize(image) {
    if (!this.model.get('originalImageSize')) {
      this.model.set('originalImageSize', { height: image.height(), width: image.width() });
    }
  }

  setImageSize(mapContainer, image) {
    if (this.model.get('isSectionMapZoomedIn')) {
      this.setZoomedImageSize(mapContainer, image);
    } else {
      this.setUnzoomedImageSize(mapContainer, image);
    }
  }

  setZoomedImageSize(mapContainer, image) {
    const originalImageSize = this.model.get('originalImageSize');
    image.css(originalImageSize);
    this.scrollContainer(mapContainer, originalImageSize);
  }

  scrollContainer(mapContainer, originalImageSize) {
    const scrollLeftPosition = (originalImageSize.width - mapContainer.width()) / 2;
    const scrollTopPosition = (originalImageSize.height - mapContainer.height()) / 2;

    mapContainer.scrollLeft(scrollLeftPosition);
    mapContainer.scrollTop(scrollTopPosition);
  }

  setUnzoomedImageSize(mapContainer, image) {
    if (mapContainer.height() > image.height() / 2) {
      // This means that the unzoomed map image fits in the container
      image.css({ width: mapContainer.width() });
    } else {
      image.css({ height: mapContainer.height() });
    }
  }

  imageErrorHandler() {
    this.$el.find('.section-map-wrapper').removeClass('gig-spinner');
    this.$el.find('#seat-map-image').hide();
    this.$el.find('#image-loading-error').show();
    this.$el.find('.zoom-button').attr('disabled', true);
  }

  zoomSectionMapWrapper() {
    const mapContainer = this.$el.find('.section-map-wrapper');
    mapContainer.addClass('zoomed-section-map-wrapper');
  }

  unzoomSectionMapWrapper() {
    const mapContainer = this.$el.find('.section-map-wrapper');
    mapContainer.removeClass('zoomed-section-map-wrapper');
  }

  resetOriginalImageSizeModel() {
    this.model.unset('originalImageSize');
  }
}

module.exports = SectionMapView;
